import { render } from "./AllTalents.vue?vue&type=template&id=b375ef06&scoped=true&ts=true&lang=pug"
import script from "./AllTalents.vue?vue&type=script&lang=ts"
export * from "./AllTalents.vue?vue&type=script&lang=ts"

import "./AllTalents.vue?vue&type=style&index=0&id=b375ef06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b375ef06"]])

export default __exports__